module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMjU2IDQ4QzE0MS4zIDQ4IDQ4IDE0MS4zIDQ4IDI1NnM5My4zIDIwOCAyMDggMjA4IDIwOC05My4zIDIwOC0yMDhTMzcwLjcgNDggMjU2IDQ4ek0yNTYgODBjOTcuNCAwIDE3NiA3OC42IDE3NiAxNzZzLTc4LjYgMTc2LTE3NiAxNzZTODAgMzUzLjQgODAgMjU2IDE1OC42IDgwIDI1NiA4MHpNMTYwIDI0MHYzMmgxOTJ2LTMySDE2MHoiLz48L3N2Zz4="


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/svg/ok.svg
 ** module id = 1103
 ** module chunks = 0
 **/